// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"e36b67d0","363":"199be160","575":"b326df6d"}[chunkId] + ".chunk.js";
};